import {
  AutocompleteInput,
  ArrayInput,
  BooleanInput,
  Create,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
} from 'react-admin';

// Facility types shared with the place-of-death picker (aura-app + admin).
export const PLACE_TYPE_CHOICES = [
  { id: 'Hospital', name: 'Hospital' },
  { id: 'CHSLD', name: 'CHSLD' },
  { id: 'Palliative', name: 'Palliative care residence' },
  // Private seniors' residence (RPA). Kept for history; not offered by the
  // place-of-death picker, which lists Hospital / CHSLD / Palliative only.
  { id: 'Residence', name: "Seniors' residence (RPA)" },
  { id: 'Cemetery', name: 'Cemetery' },
  { id: 'Synagogue', name: 'Synagogue' },
];

export const PLACE_REGION_CHOICES = [
  { id: 'quebec', name: 'Quebec' },
  { id: 'ontario', name: 'Ontario' },
];

// Phone labels the place-of-death modal understands (see PlaceOfDeathModal).
export const PLACE_PHONE_LABEL_CHOICES = [
  { id: 'general', name: 'General' },
  { id: 'admitting', name: 'Admitting' },
  { id: 'records', name: 'Records' },
  { id: 'pathology', name: 'Pathology' },
  { id: 'after_hours', name: 'After hours' },
  { id: 'palliative', name: 'Palliative care' },
  { id: 'nursing_coordinator', name: 'Nursing coordinator' },
  { id: 'direct', name: 'Direct' },
  { id: 'security', name: 'Security' },
];

export const PlacesCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <TextInput source="abbreviation" />
      <TextInput source="address" />
      <TextInput source="city" />
      <TextInput source="state" label="Province" />
      <TextInput source="postal_code" />
      <SelectInput source="type" validate={[required()]} choices={PLACE_TYPE_CHOICES} />
      {/* Region scopes the place-of-death facility picker; leave empty to apply to both. */}
      <SelectInput source="region" choices={PLACE_REGION_CHOICES} helperText="Leave empty to apply to both provinces" />
      <TextInput source="phone_number" label="Primary phone" />
      {/* Staff/agent-facing contact lines shown in the place-of-death modal. */}
      <ArrayInput source="phones" label="Phone lines (admitting, pathology, …)">
        <SimpleFormIterator inline>
          <SelectInput source="label" choices={PLACE_PHONE_LABEL_CHOICES} helperText={false} />
          <TextInput source="number" helperText={false} />
          <TextInput source="ext" label="Ext." helperText={false} />
        </SimpleFormIterator>
      </ArrayInput>
      <ReferenceInput reference="places" source="parent_id" filter={{ type: 'Cemetery' }}>
        <AutocompleteInput optionText="name" label="Cemetery" helperText={false} />
      </ReferenceInput>
      <BooleanInput source="active" defaultValue={true} />
    </SimpleForm>
  </Create>
);
